import React from 'react'
import { useClipboard } from '@chakra-ui/react'
import { FaCheck, FaClipboard } from 'react-icons/fa6'

import { MessageActionsProps } from './'
import { getCopyMessageText } from '../../helpers'
import MenuItem from '~components/shared/menu/menu-item'

export default function CopyMessageAction({
    message,
}: Pick<MessageActionsProps, 'message'>) {
    const { hasCopied, onCopy } = useClipboard(getCopyMessageText(message))

    return (
        <MenuItem icon={hasCopied ? FaCheck : FaClipboard} onClick={onCopy}>
            {hasCopied ? 'Copied!' : 'Copy Message'}
        </MenuItem>
    )
}
